var _path, _path2, _path3, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4019 7.5C21.5566 5.5 24.4434 5.5 25.5981 7.5L37.7224 28.5C38.8771 30.5 37.4338 33 35.1244 33H10.8756C8.56624 33 7.12287 30.5 8.27757 28.5L20.4019 7.5Z",
    fill: "#F3576C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8971 5.75C25.1651 2.75 20.8349 2.75 19.1029 5.75L6.1125 28.25C4.38045 31.25 6.54552 35 10.0096 35H35.9904C39.4545 35 41.6195 31.25 39.8875 28.25L26.8971 5.75Z",
    stroke: "#F3576C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 11C24.1046 11 25 11.8954 25 13V23C25 24.1046 24.1046 25 23 25C21.8954 25 21 24.1046 21 23V13C21 11.8954 21.8954 11 23 11Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 29,
    r: 2,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleted);
export default __webpack_public_path__ + "static/media/deleted.d50d67e57adab69507782dead5f23d69.svg";
export { ForwardRef as ReactComponent };